import React from 'react';
import PropTypes from 'prop-types';
import { useChannelStatus, useUserRole } from '../../../slice';
import { handleChannelStatusAction } from '../../utils';

export const ActionButton = ({ icon, label, onClick }) => (
    <button className="action_button" onClick={onClick}>
        <i>{icon}</i>
        <span>{label}</span>
    </button>
);

ActionButton.propTypes = {
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

function ChannelActivationBase({ channelId }) {
    const activeStatus = useChannelStatus(channelId);
    const userRole = useUserRole(channelId);
    const inActive = activeStatus === 'INACTIVE' && (userRole === 1 || userRole === 2);
    return (
        <>
            {inActive && (
                <div className="activevate-channel">
                    <button
                        type="button"
                        onClick={() => handleChannelStatusAction({ channelId, active: true })}
                        aria-pressed={inActive}
                    >
                        Activate Channel
                    </button>
                </div>
            )}
        </>
    );
}

const ChannelActivationToggle = React.memo(ChannelActivationBase);
export { ChannelActivationToggle };

ChannelActivationBase.propTypes = {
    channelId: PropTypes.string.isRequired,
};
